/* MailBakes 2026 collection engine. Owned by sections/mb-collection.liquid.
   Spec: "MailBakes 2026 - Collection Page Build Spec - LOCKED v1.1".

   What lives here (functional logic locked in code, per 1. Global rules):
   - tag-driven filter groups (group:value tags, 3.7) with OR within a group
     and AND across groups (3.3)
   - fixed deep-link params who/milestone/style/occasion/sentiment with
     lowercase hyphenated slugs mapped one-to-one to tag values (3.6)
   - H1 swap rules (4.2) + self-canonical/unique-title on single-filter
     states, parent canonical otherwise (3.6)
   - sort: Bestselling default, Newest, nothing else (5.)
   - thin-results fallback with priority + cascade (5.1)
   - grid batches of 24 with skeletons, crawl-safe (5.2): finite Load-more
     batches by DEFAULT - they carry ?offset= and leave the page links
     visible. Auto-loading only where the section's "Load more button"
     setting is switched off (Birthday). ?page=N renders exactly its own
     window of 24 in BOTH modes - that part is crawler-facing only
   - Reset renders only when a filter is active (3.3)

   Data: one fetch series against the mb-data section (Section Rendering API)
   with sort_by=best-selling, 250 products a page. Arrival order IS the
   bestselling rank; Newest sorts client-side on published_at. The daily badge
   job's mailbakes.badge metafield rides along for tile badges. */
(function () {
  'use strict';

  var root = document.getElementById('mb2-root');
  if (!root) return;
  var cfgEl = root.querySelector('[data-mb2-config]');
  var grid = root.querySelector('[data-mb2-grid]');
  if (!cfgEl || !grid) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* Optional per-collection allow-list for the Occasion pill, set per template.
     EMPTY means show every occasion value the collection's products carry -
     which is the behaviour on every collection except Celebrations, where the
     smart collection's own rule set is mirrored here. Canonical tag values,
     not slugs. Values are accepted comma- or newline-separated. */
  var OCCASION_ALLOW = String(cfg.occasionAllow || '')
    .split(/[\n,]/)
    .map(function (x) { return x.trim(); })
    .filter(Boolean);

  var bar = root.querySelector('[data-mb2-bar]');
  var pillsEl = root.querySelector('[data-mb2-pills]');
  var chipsEl = root.querySelector('[data-mb2-chips]');
  var countEl = root.querySelector('[data-mb2-count]');
  var sortEl = root.querySelector('[data-mb2-sort]');
  var progressEl = root.querySelector('[data-mb2-progress]');
  var loadBtn = root.querySelector('[data-mb2-loadbtn]');
  var pagenav = root.querySelector('[data-mb2-pagenav]');
  var fbWrap = root.querySelector('[data-mb2-fb]');
  var fbGrid = root.querySelector('[data-mb2-fbgrid]');
  var h1El = root.querySelector('[data-mb2-h1]');
  var crumbMid = root.querySelector('[data-mb2-crumb-mid]');
  var drawer = root.querySelector('[data-mb2-drawer]');
  var drawerBody = root.querySelector('[data-mb2-drawer-body]');
  var drawerCta = root.querySelector('[data-mb2-drawer-cta]');
  var drawerReset = root.querySelector('[data-mb2-drawer-reset]');
  var scrim = root.querySelector('[data-mb2-scrim]');

  /* ---- group model (3.4 / 3.6 / 5.1 - LOCKED) --------------------------- */
  var GROUP_ORDER = ['who', 'milestone', 'occasion', 'style'];
  var PARAM_ORDER = ['who', 'milestone', 'style', 'occasion'];
  var PRIORITY = { milestone: 1, occasion: 1, who: 2, style: 3 };
  var NOUN_GROUPS = { who: true, milestone: true };   /* H1 keeps the collection noun */
  var WHO_CANON = ['For Her', 'For Him', 'Mum', 'Dad', 'Daughter', 'Son', 'Sister', 'Brother',
    'Friend', 'Partner', 'Wife', 'Husband', 'Girlfriend', 'Boyfriend', 'Kids', 'Grandparents',
    'Grandchildren', 'Auntie', 'Uncle', 'Niece', 'Nephew', 'Cousin', 'From the Kids', 'From the Pets'];
  var SMALL_WORDS = { of: 1, in: 1, a: 1, an: 1, the: 1, for: 1, to: 1, and: 1 };

  /* slug: lowercase, hyphenated, no spaces/capitals/encoded chars (3.6).
     One-to-one with the canonical tag value; built from the value itself. */
  function slugOf(value) {
    return value
      .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
      .replace(/[^A-Za-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
  function displayOf(value) {
    var words = value.replace(/([a-z0-9])([A-Z])/g, '$1 $2').split(/\s+/);
    return words.map(function (w, i) {
      return (i > 0 && SMALL_WORDS[w.toLowerCase()]) ? w.toLowerCase() : w;
    }).join(' ');
  }

  /* ---- state ------------------------------------------------------------ */
  var products = [];            /* bestselling order */
  var groups = {};              /* key -> [{value, slug, display, count}] */
  var slugMap = {};             /* key -> {slug: value} */
  var active = {};              /* key -> [value, ...] */
  var clickOrder = [];          /* group keys in the order they gained values */
  var sort = 'best-selling';
  var rendered = 0;

  /* review tiles interleaved into the grid (revisions doc, section 6) */
  var REVIEWS = [];
  String(cfg.reviewsRaw || '').split('\n').forEach(function (l) {
    l = l.trim();
    if (!l) return;
    var p = l.split('|');
    REVIEWS.push({ q: (p[0] || '').trim(), n: (p[1] || '').trim() });
  });
  var REVIEW_EVERY = Math.max(1, cfg.reviewEvery || 9);
  var matched = [];
  var busy = false;
  var openDD = null;

  /* Finite batching - the DEFAULT since Aug 2026. ON: the grid renders a
     batch and stops, so whatever sits under it - the FAQ block, the page
     links, the footer - is reachable after every batch instead of receding.
     The batch depth rides in the URL as ?offset=<n>, so a scrolled state is
     shareable and survives Back. OFF: the old uncapped auto-load, kept for
     Birthday only. */
  var MANUAL = !!cfg.manualBatches;
  var pendingOffset = 0;   /* cumulative depth from ?offset=, consumed on apply */
  var startAt = 0;         /* absolute index of the first product in the grid */
  var pendingStart = 0;    /* window start from ?page=, consumed on apply */

  /* How many of `matched` are still un-rendered from the current window on. */
  function remaining() { return Math.max(0, matched.length - startAt - rendered); }

  function activeGroups() { return GROUP_ORDER.filter(function (k) { return (active[k] || []).length > 0; }); }
  function activeTotal() { return activeGroups().reduce(function (n, k) { return n + active[k].length; }, 0); }

  /* ---- URL state (3.6) --------------------------------------------------- */
  /* Set by readURL() when the template's default occasion was applied
     because the URL carried no filter (lp-birthday brief, Sep 2026). */
  var defaultedOccasion = false;

  function readURL() {
    var q = new URLSearchParams(window.location.search);
    active = {};
    PARAM_ORDER.forEach(function (k) {
      var raw = q.get(k);
      if (!raw) return;
      var vals = raw.split(',').map(function (s) { return (slugMap[k] || {})[s.trim()]; }).filter(Boolean);
      if (vals.length) active[k] = vals;
    });
    /* Template default: on a bare URL (no filter params at all) pre-select
       cfg.defaultOccasion in the Occasion group. Any explicit param wins,
       so deep links, Back and shared URLs behave exactly as before. */
    defaultedOccasion = false;
    if (cfg.defaultOccasion && !PARAM_ORDER.some(function (k) { return q.has(k); })) {
      var dv = String(cfg.defaultOccasion).trim();
      var known = (groups.occasion || []).some(function (o) { return o.value === dv; });
      if (known) { active.occasion = [dv]; defaultedOccasion = true; }
    }
    /* ?offset= is ours (batched mode writes it); ?page= is the server's
       crawlable pagination. Both mean "render this deep".

       The ?page= arm is deliberately NOT gated on batching mode. Without it,
       hydration replaces a server-rendered page 2 with page 1, so every
       paginated URL shows a JS-rendering crawler the same first 24 products -
       which would defeat the point of publishing the page links at all. That
       applies just as much to an auto-load collection, and honouring it costs
       a human nothing: landing on ?page=2 without the param set is what the
       page links already promise, and no on-site control produces a ?page=
       URL in auto-load mode, so the visible journey is untouched. */
    pendingOffset = 0;
    pendingStart = 0;
    var off = MANUAL ? parseInt(q.get('offset'), 10) : NaN;
    if (isFinite(off) && off > 0) {
      pendingOffset = off;                 /* cumulative: render 0..off */
    } else {
      var pg = parseInt(q.get('page'), 10);
      if (isFinite(pg) && pg > 1) pendingStart = (pg - 1) * cfg.perBatch;
    }
    var s = q.get('sort_by');
    sort = (s === 'created-descending') ? 'created-descending' : 'best-selling';
    /* deep-linked arrival: no click order exists, cascade uses priority order (5.1) */
    clickOrder = activeGroups().sort(function (a, b) { return PRIORITY[a] - PRIORITY[b]; });
  }

  function writeURL(push) {
    var q = new URLSearchParams();
    PARAM_ORDER.forEach(function (k) {
      var vals = active[k] || [];
      if (vals.length) q.set(k, vals.map(slugOf).join(','));
    });
    if (sort !== 'best-selling') q.set('sort_by', sort);
    /* Batch depth is part of the shareable state, but only past the first
       batch - the bare collection URL has to stay clean for the canonical. */
    if (MANUAL && startAt === 0 && rendered > cfg.perBatch) q.set('offset', String(rendered));
    var qs = q.toString();
    var url = window.location.pathname + (qs ? '?' + qs : '');
    if (url === window.location.pathname + window.location.search) return;
    if (push) history.pushState({ mb2: 1 }, '', url);
    else history.replaceState({ mb2: 1 }, '', url);
  }

  /* ---- H1 swap + SEO (4.2 / 3.6) ---------------------------------------- */
  function singleSwapState() {
    var ag = activeGroups();
    if (ag.length !== 1) return null;
    var k = ag[0];
    if (k === 'style') return null;                 /* Style never swaps */
    if (active[k].length !== 1) return null;
    return { group: k, value: active[k][0] };
  }

  function applyHead() {
    var swap = singleSwapState();
    /* The template default is the page's resting state, not a filtered
       deep link: keep the parent H1, canonical and title. */
    if (swap && defaultedOccasion && swap.group === 'occasion' && activeTotal() === 1 &&
        swap.value === String(cfg.defaultOccasion).trim()) swap = null;
    var h1 = cfg.h1Default;
    if (swap) {
      var disp = displayOf(swap.value);
      h1 = NOUN_GROUPS[swap.group]
        ? disp + ' ' + cfg.noun + ' Cake Cards'
        : disp + ' Cake Cards';
    }
    if (h1El && h1El.textContent !== h1) h1El.textContent = h1;

    /* breadcrumb third level only when the H1 swaps (4.2) */
    if (crumbMid) {
      var ol = crumbMid.parentNode;
      var leaf = ol.querySelector('[data-mb2-crumb-leaf]');
      if (swap) {
        crumbMid.innerHTML = '<a href="' + cfg.url + '">' + cfg.crumbNav + '</a>';
        if (!leaf) {
          leaf = document.createElement('li');
          leaf.setAttribute('data-mb2-crumb-leaf', '');
          ol.appendChild(leaf);
        }
        leaf.innerHTML = '<span aria-current="page">' + h1.replace(/ Cake Cards$/, '') + '</span>';
      } else {
        crumbMid.innerHTML = '<span aria-current="page">' + cfg.crumbNav + '</span>';
        if (leaf) leaf.parentNode.removeChild(leaf);
      }
    }

    /* canonical: self on single-swap states, parent collection otherwise (3.6) */
    var canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement('link');
      canon.setAttribute('rel', 'canonical');
      document.head.appendChild(canon);
    }
    if (swap) {
      canon.setAttribute('href', cfg.shopUrl + cfg.url + '?' + swap.group + '=' + slugOf(swap.value));
      document.title = h1 + (cfg.titleSuffix || '');
    } else {
      canon.setAttribute('href', cfg.shopUrl + cfg.url);
      if (activeTotal() === 0) document.title = cfg.h1Default + (cfg.titleSuffix || '');
    }
  }

  /* ---- filtering + sorting (3.3 / 5.) ----------------------------------- */
  function matches(p, skipGroup) {
    for (var i = 0; i < GROUP_ORDER.length; i++) {
      var k = GROUP_ORDER[i];
      if (k === skipGroup) continue;
      var vals = active[k] || [];
      if (!vals.length) continue;
      var hit = false;
      for (var j = 0; j < vals.length; j++) {
        if (p.tagSet[k + ':' + vals[j]]) { hit = true; break; }
      }
      if (!hit) return false;                       /* AND across groups */
    }
    return true;                                    /* OR within a group */
  }

  function computeMatched() {
    matched = products.filter(function (p) { return matches(p); });
    if (sort === 'created-descending') {
      matched = matched.slice().sort(function (a, b) { return (b.pub || 0) - (a.pub || 0); });
    }
  }

  /* ---- tiles ------------------------------------------------------------ */
  function tileHTML(p) {
    var badge = '';
    var label = p.b && cfg.badgeLabels[p.b];
    if (label) badge = '<span class="mb2-badge">' + esc(label) + '</span>';
    var img = p.img ? '<img src="' + p.img + '" alt="' + esc(p.t) + '" width="600" height="800" loading="lazy">' : '';
    /* All designs are the same price, so the tile shows a star rating instead
       of a price - from 3 reviews up. The row renders even when empty so
       every tile is exactly the same height. */
    var rate = '';
    var rv = parseFloat(p.r);
    if (p.rc >= 3 && rv > 0) {
      var pct = Math.max(0, Math.min(100, rv * 20));
      rate = '<span class="mb2-st" aria-hidden="true"><i style="width:' + pct + '%">&#9733;&#9733;&#9733;&#9733;&#9733;</i>&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
        '<span class="mb2-tile__rn">' + (Math.round(rv * 10) / 10) + ' (' + p.rc + ')</span>';
    }
    return '<a class="mb2-tile" href="' + p.u + '">' +
      '<div class="mb2-tile__im">' + badge + img + '</div>' +
      '<div class="mb2-tile__b">' +
      '<div class="mb2-tile__nm">' + esc(p.t) + '</div>' +
      '<div class="mb2-tile__rt">' + rate + '</div></div></a>';
  }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function reviewTileHTML(absIdx) {
    var r = REVIEWS[(Math.round(absIdx / REVIEW_EVERY) - 1 + REVIEWS.length * 1000) % REVIEWS.length];
    if (!r) return '';
    return '<div class="mb2-tile mb2-review" role="figure" aria-label="Customer review">' +
      '<div class="mb2-review__c">' +
      '<div class="mb2-review__st" aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</div>' +
      '<p class="mb2-review__q">&ldquo;' + esc(r.q) + '&rdquo;</p>' +
      (r.n ? '<div class="mb2-review__n">' + esc(r.n) + '</div>' : '') +
      '<div class="mb2-review__v">&#10003; ' + esc(cfg.reviewVerified || 'Verified buyer') + '</div>' +
      '</div></div>';
  }
  function skeletonHTML() {
    return '<div class="mb2-tile mb2-skel" aria-hidden="true">' +
      '<div class="mb2-tile__im"></div>' +
      '<div class="mb2-tile__b">' +
      '<div class="mb2-tile__nm"><span class="mb2-sk"></span><span class="mb2-sk"></span></div>' +
      '<div class="mb2-tile__rt"><span class="mb2-sk"></span></div></div></div>';
  }

  /* ---- grid rendering (5.2) --------------------------------------------- */
  function renderBatch(reset) {
    if (reset) { grid.innerHTML = ''; rendered = 0; }
    var next = matched.slice(startAt + rendered, startAt + rendered + cfg.perBatch);
    var html = '';
    for (var i = 0; i < next.length; i++) {
      html += tileHTML(next[i]);
      var absIdx = startAt + rendered + i + 1;
      if (REVIEWS.length && absIdx % REVIEW_EVERY === 0) html += reviewTileHTML(absIdx);
    }
    grid.insertAdjacentHTML('beforeend', html);
    rendered += next.length;
    renderProgress();
    save();
  }

  function renderProgress() {
    if (!progressEl) return;
    progressEl.textContent = String(cfg.progressFormat || 'Showing {shown} of {total} designs')
      .replace('{shown}', rendered).replace('{total}', matched.length);
  }

  /* ---- thin-results fallback (5.1 - LOCKED) ------------------------------ */
  function fbLimit() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 4 : 8;
  }

  function renderFallback() {
    if (!fbWrap || !fbGrid) return;
    var thin = activeTotal() > 0 && matched.length < 4;
    fbWrap.hidden = !thin;
    if (!thin) { fbGrid.innerHTML = ''; return; }

    var limit = fbLimit();
    var shownIds = {};
    matched.forEach(function (p) { shownIds[p.id] = 1; });
    var picked = [];
    var pickedIds = {};

    function pull(list) {
      for (var i = 0; i < list.length && picked.length < limit; i++) {
        var p = list[i];
        if (shownIds[p.id] || pickedIds[p.id]) continue;   /* excludes shown; no dupes */
        picked.push(p); pickedIds[p.id] = 1;
      }
    }

    /* priority group first: best sellers matching that group's active values */
    function groupBest(k) {
      var vals = active[k] || [];
      return products.filter(function (p) {
        for (var j = 0; j < vals.length; j++) if (p.tagSet[k + ':' + vals[j]]) return true;
        return false;
      });
    }

    var ag = activeGroups();
    var ordered = ag.slice().sort(function (a, b) { return PRIORITY[a] - PRIORITY[b]; });
    var primary = ordered[0];
    if (primary) pull(groupBest(primary));

    /* cascade: other active groups in reverse order of application, then the
       overall collection best sellers - only if still short */
    if (picked.length < limit) {
      var rest = clickOrder.filter(function (k) { return k !== primary && (active[k] || []).length; }).reverse();
      for (var r = 0; r < rest.length && picked.length < limit; r++) pull(groupBest(rest[r]));
    }
    if (picked.length < limit) pull(products);

    var html = '';
    for (var i = 0; i < picked.length; i++) html += tileHTML(picked[i]);
    fbGrid.innerHTML = html;
  }

  /* ---- filter bar UI ---------------------------------------------------- */
  function facetCount(k, value) {
    var n = 0;
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (p.tagSet[k + ':' + value] && matches(p, k)) n++;
    }
    return n;
  }

  function renderPills() {
    var html = '';
    GROUP_ORDER.forEach(function (k) {
      var vals = groups[k];
      if (!vals || !vals.length) return;            /* value hygiene (3.4) */
      var act = (active[k] || []).length;
      html += '<div class="mb2-dd" data-mb2-dd="' + k + '">' +
        '<button type="button" class="mb2-pill' + (act ? ' is-on' : '') + '" aria-expanded="false" data-mb2-ddbtn="' + k + '">' +
        esc(cfg.groups[k] || k) + (act ? ' <span class="mb2-nbadge">&middot; ' + act + '</span>' : '') +
        ' <svg class="mb2-chev" viewBox="0 0 12 8" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M1 1l5 5 5-5"/></svg>' +
        '</button><div class="mb2-dd__panel" role="group" aria-label="' + esc(cfg.groups[k] || k) + '">';
      vals.forEach(function (v) {
        var on = (active[k] || []).indexOf(v.value) !== -1;
        var n = facetCount(k, v.value);
        /* Value hygiene (3.4) is about the COLLECTION - every value here has
           >=1 tagged product. A value that would give 0 results with the
           CURRENT selection stays visible (dimmed) and selectable: the
           thin-results fallback (5.1) exists precisely for that combo. */
        html += '<label class="mb2-opt"' + (n === 0 && !on ? ' style="opacity:.45"' : '') + '><input type="checkbox" data-mb2-opt="' + k + '" value="' + esc(v.value) + '"' +
          (on ? ' checked' : '') + '> ' + esc(v.display) + '<span class="mb2-opt__n">' + n + '</span></label>';
      });
      html += '</div></div>';
    });
    pillsEl.innerHTML = html;
    /* keep the open dropdown open across re-renders */
    if (openDD) {
      var dd = pillsEl.querySelector('[data-mb2-dd="' + openDD + '"]');
      if (dd) {
        dd.classList.add('is-open');
        var b = dd.querySelector('[data-mb2-ddbtn]');
        if (b) b.setAttribute('aria-expanded', 'true');
        positionDD();
      }
    }
  }

  function renderChips() {
    var html = '';
    GROUP_ORDER.forEach(function (k) {
      (active[k] || []).forEach(function (v) {
        html += '<button type="button" class="mb2-chip" data-mb2-chip="' + k + '" value="' + esc(v) + '">' +
          esc(displayOf(v)) + ' <b aria-hidden="true">&times;</b></button>';
      });
    });
    /* Reset renders ONLY when at least one filter is active (3.3) */
    if (activeTotal() > 0) {
      html += '<button type="button" class="mb2-reset" data-mb2-reset>' + esc(cfg.resetLabel) + '</button>';
    }
    chipsEl.innerHTML = html;
  }

  function renderCount() {
    if (countEl) countEl.textContent = matched.length + ' ' + (cfg.countLabel || 'designs');
    if (drawerCta) drawerCta.textContent = String(cfg.drawerCta || 'Show [count] designs').replace('[count]', matched.length);
    if (drawerReset) drawerReset.hidden = activeTotal() === 0;
  }

  function renderDrawer() {
    if (!drawerBody) return;
    var html = '';
    GROUP_ORDER.forEach(function (k) {
      var vals = groups[k];
      if (!vals || !vals.length) return;
      html += '<div class="mb2-drawer__grp"><h4>' + esc(cfg.groups[k] || k) + '</h4>';
      vals.forEach(function (v) {
        var on = (active[k] || []).indexOf(v.value) !== -1;
        var n = facetCount(k, v.value);
        html += '<label class="mb2-opt"' + (n === 0 && !on ? ' style="opacity:.45"' : '') + '><input type="checkbox" data-mb2-opt="' + k + '" value="' + esc(v.value) + '"' +
          (on ? ' checked' : '') + '> ' + esc(v.display) + '<span class="mb2-opt__n">' + n + '</span></label>';
      });
      html += '</div>';
    });
    drawerBody.innerHTML = html;
  }

  /* ---- render depth / window from the URL --------------------------------- */
  /* Two different jobs, deliberately kept apart:

     ?offset=<n>  cumulative, and user-facing. It is what Load more writes, so
                  someone sharing their position expects everything above it.
                  Batched mode only.

     ?page=<n>    a WINDOW, and crawler-facing. Renders exactly that page's own
                  24 and nothing else, in both modes. Cumulative would make
                  every deep URL re-render thousands of tiles for the same 24
                  new products - wasted crawl budget, and every paginated URL
                  overlapping the last. The window start is applied in apply(). */
  function applyOffset() {
    if (pendingOffset <= 0) { pendingOffset = 0; return; }
    var target = Math.min(pendingOffset, matched.length);
    pendingOffset = 0;
    while (rendered < target && remaining() > 0) renderBatch(false);
  }

  /* The Load more button is server-rendered as the no-JS fallback. In finite
     mode it is promoted to the real control, so it has to track whether any
     designs are actually left. */
  function syncLoadBtn() {
    if (!loadBtn) return;
    if (!MANUAL) { loadBtn.hidden = true; return; }
    var more = remaining();
    loadBtn.hidden = more <= 0;
    loadBtn.disabled = false;
    if (more > 0) loadBtn.textContent = String(cfg.loadMoreLabel || 'Load more designs');
  }

  /* ---- apply ------------------------------------------------------------ */
  function apply(opts) {
    opts = opts || {};
    computeMatched();
    renderPills();
    renderChips();
    renderCount();
    renderDrawer();
    applyHead();
    /* Only a ?page= URL sets a window; any other re-apply (filter, sort,
       reset) starts from the top again. */
    startAt = pendingStart;
    pendingStart = 0;
    renderBatch(true);                              /* fresh first batch (3.6) */
    applyOffset();
    renderFallback();
    if (!opts.noURL) writeURL(!!opts.push);
    syncLoadBtn();
    if (opts.scroll) {
      var y = grid.getBoundingClientRect().top + window.pageYOffset - 64;
      window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
    }
  }

  function setValue(k, value, on, fromUser) {
    var vals = (active[k] || []).slice();
    var i = vals.indexOf(value);
    if (on && i === -1) vals.push(value);
    if (!on && i !== -1) vals.splice(i, 1);
    if (vals.length) active[k] = vals; else delete active[k];
    var ci = clickOrder.indexOf(k);
    if (vals.length && ci === -1) clickOrder.push(k);
    if (!vals.length && ci !== -1) clickOrder.splice(ci, 1);
    apply({ push: !!fromUser });
  }

  function resetAll() {
    active = {}; clickOrder = [];
    apply({ push: true, scroll: true });
  }

  /* ---- events ----------------------------------------------------------- */
  /* The pill row is a horizontal scroller (overflow-x:auto), which CLIPS an
     absolutely-positioned child panel. Panels are therefore positioned FIXED
     at the button's viewport rect on open, and re-anchored on scroll/resize. */
  function positionDD() {
    if (!openDD) return;
    var dd = pillsEl.querySelector('[data-mb2-dd="' + openDD + '"]');
    if (!dd) return;
    var btn = dd.querySelector('[data-mb2-ddbtn]');
    var panel = dd.querySelector('.mb2-dd__panel');
    if (!btn || !panel) return;
    var r = btn.getBoundingClientRect();
    panel.style.position = 'fixed';
    panel.style.top = Math.round(r.bottom + 8) + 'px';
    panel.style.left = Math.round(Math.max(8, Math.min(r.left, window.innerWidth - panel.offsetWidth - 8))) + 'px';
    panel.style.zIndex = '230';
    panel.style.maxHeight = Math.max(160, window.innerHeight - r.bottom - 24) + 'px';
  }
  var posTick = false;
  function onViewportChange() {
    if (posTick || !openDD) return;
    posTick = true;
    window.requestAnimationFrame(function () { posTick = false; positionDD(); });
  }
  window.addEventListener('scroll', onViewportChange, { passive: true });
  window.addEventListener('resize', onViewportChange, { passive: true });

  root.addEventListener('click', function (e) {
    var t = e.target;
    var ddbtn = t.closest ? t.closest('[data-mb2-ddbtn]') : null;
    if (ddbtn) {
      var k = ddbtn.getAttribute('data-mb2-ddbtn');
      var dd = ddbtn.parentNode;
      var was = dd.classList.contains('is-open');
      closeDD();
      if (!was) {
        dd.classList.add('is-open');
        ddbtn.setAttribute('aria-expanded', 'true');
        openDD = k;
        positionDD();
      }
      e.stopPropagation();
      return;
    }
    var chip = t.closest ? t.closest('[data-mb2-chip]') : null;
    if (chip) { setValue(chip.getAttribute('data-mb2-chip'), chip.value, false, true); return; }
    if (t.closest && t.closest('[data-mb2-reset]')) { resetAll(); return; }
    if (t.closest && t.closest('[data-mb2-drawer-open]')) { openDrawer(true); return; }
    if (t.closest && (t.closest('[data-mb2-drawer-close]') || t.closest('[data-mb2-scrim]'))) { openDrawer(false); return; }
    if (t.closest && t.closest('[data-mb2-drawer-cta]')) { openDrawer(false); return; }
    if (t.closest && t.closest('[data-mb2-drawer-reset]')) { resetAll(); openDrawer(false); return; }
    if (!t.closest || !t.closest('.mb2-dd')) closeDD();
  });

  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) closeDD();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDD(); openDrawer(false); }
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-mb2-opt')) {
      setValue(t.getAttribute('data-mb2-opt'), t.value, t.checked, true);
    }
  });

  if (sortEl) sortEl.addEventListener('change', function () {
    sort = sortEl.value === 'created-descending' ? 'created-descending' : 'best-selling';
    apply({ push: true, scroll: true });
  });

  window.addEventListener('popstate', function () {
    readURL();
    if (sortEl) sortEl.value = sort;
    apply({ noURL: true });
  });

  function closeDD() {
    openDD = null;
    var open = pillsEl.querySelectorAll('.mb2-dd.is-open');
    for (var i = 0; i < open.length; i++) {
      open[i].classList.remove('is-open');
      var b = open[i].querySelector('[data-mb2-ddbtn]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
  }

  function openDrawer(on) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', on);
    drawer.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (scrim) scrim.classList.toggle('is-open', on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }

  /* ---- sticky border (3.1) ---------------------------------------------- */
  if (bar && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'height:1px;margin-bottom:-1px';
    bar.parentNode.insertBefore(sentinel, bar);
    new IntersectionObserver(function (es) {
      bar.classList.toggle('is-stuck', !es[0].isIntersecting);
    }, { rootMargin: '-1px 0px 0px 0px' }).observe(sentinel);
  }

  /* ---- auto-load (5.2): batches of 24, skeletons, next batch ~900px before
     the end. Disabled when MANUAL - there the Load more button is the only
     thing that advances the grid, which is exactly what keeps the FAQ block
     and the footer reachable after every batch. */
  var TRIGGER = 900;
  var tick = false;
  function maybeLoad() {
    if (MANUAL) return;                             /* the button drives it */
    if (tick) return;
    tick = true;
    window.requestAnimationFrame(function () {
      tick = false;
      if (busy || remaining() <= 0) return;
      var box = grid.getBoundingClientRect();
      if (box.bottom - window.innerHeight < TRIGGER) {
        busy = true;
        var n = Math.min(cfg.perBatch, remaining());
        var sk = '';
        for (var i = 0; i < n; i++) sk += skeletonHTML();
        grid.insertAdjacentHTML('beforeend', sk);
        window.requestAnimationFrame(function () {
          var skels = grid.querySelectorAll('.mb2-skel');
          for (var i = 0; i < skels.length; i++) skels[i].parentNode.removeChild(skels[i]);
          renderBatch(false);
          busy = false;
          maybeLoad();
        });
      }
    });
  }
  window.addEventListener('scroll', maybeLoad, { passive: true });
  window.addEventListener('resize', maybeLoad, { passive: true });

  /* ---- scroll + batch restoration on browser Back (5.2) ------------------ */
  function storageKey() {
    var q = new URLSearchParams(window.location.search);
    q.delete('page'); q.delete('offset'); q.sort();
    var s = q.toString();
    return 'mb2:' + window.location.pathname + (s ? '?' + s : '');
  }
  function save() {
    /* storageKey() deliberately ignores ?page=, so a windowed page must not
       write its window-relative count into the bare URL's saved state. */
    if (startAt > 0) return;
    try {
      sessionStorage.setItem(storageKey(), JSON.stringify({
        n: rendered, y: Math.round(window.pageYOffset), t: Date.now()
      }));
    } catch (e) { /* private mode */ }
  }
  var saveTick = false;
  window.addEventListener('scroll', function () {
    if (saveTick) return;
    saveTick = true;
    setTimeout(function () { saveTick = false; save(); }, 400);
  }, { passive: true });
  window.addEventListener('pagehide', save);

  function restore() {
    if (startAt > 0) return;                        /* windowed pages are exact */
    var raw;
    try { raw = sessionStorage.getItem(storageKey()); } catch (e) { return; }
    if (!raw) return;
    var st;
    try { st = JSON.parse(raw); } catch (e) { return; }
    if (!st || Date.now() - (st.t || 0) > 1800000) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    while (rendered < Math.min(st.n || 0, matched.length)) renderBatch(false);
    window.scrollTo(0, st.y || 0);
    window.requestAnimationFrame(function () { window.scrollTo(0, st.y || 0); });
  }

  /* ---- data bootstrap ---------------------------------------------------- */
  function fetchPage(page) {
    var u = cfg.url + '?section_id=mb-data&sort_by=best-selling&page=' + page;
    return fetch(u, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (text) {
      var a = text.indexOf('{');
      var b = text.lastIndexOf('}');
      if (a === -1 || b === -1) throw new Error('no json');
      return JSON.parse(text.slice(a, b + 1));
    });
  }

  function indexProducts() {
    var counts = {};
    products.forEach(function (p) {
      p.tagSet = {};
      (p.tags || []).forEach(function (tag) {
        var m = /^(who|milestone|occasion|style):(.+)$/.exec(tag);
        if (!m) return;
        var k = m[1], v = m[2].trim();
        p.tagSet[k + ':' + v] = 1;
        counts[k] = counts[k] || {};
        counts[k][v] = (counts[k][v] || 0) + 1;
      });
    });
    groups = {}; slugMap = {};
    GROUP_ORDER.forEach(function (k) {
      var vals = Object.keys(counts[k] || {});
      /* Filtering the value list here propagates to the pill, the drawer AND
         the deep-link slug map in one go, because all three derive from it.
         Note the consequence: a stripped value's ?occasion= deep link becomes
         inert - readURL() drops it through .filter(Boolean) and the page
         renders unfiltered. */
      if (k === 'occasion' && OCCASION_ALLOW.length) {
        vals = vals.filter(function (v) { return OCCASION_ALLOW.indexOf(v) !== -1; });
      }
      if (!vals.length) return;
      if (k === 'milestone') {
        vals.sort(function (a, b) { return (parseInt(a, 10) || 999) - (parseInt(b, 10) || 999); });
      } else if (k === 'who') {
        vals.sort(function (a, b) {
          var ia = WHO_CANON.indexOf(a), ib = WHO_CANON.indexOf(b);
          if (ia === -1 && ib === -1) return a.localeCompare(b);
          if (ia === -1) return 1;
          if (ib === -1) return -1;
          return ia - ib;
        });
      } else {
        vals.sort(function (a, b) { return counts[k][b] - counts[k][a] || a.localeCompare(b); });
      }
      groups[k] = vals.map(function (v) {
        return { value: v, slug: slugOf(v), display: displayOf(v), count: counts[k][v] };
      });
      slugMap[k] = {};
      groups[k].forEach(function (v) { slugMap[k][v.slug] = v.value; });
    });
  }

  function boot() {
    fetchPage(1).then(function (first) {
      products = first.products || [];
      var rest = [];
      for (var p = 2; p <= (first.pages || 1); p++) rest.push(fetchPage(p));
      return Promise.all(rest).then(function (pages) {
        pages.forEach(function (d) { products = products.concat(d.products || []); });
      });
    }).then(function () {
      if (cfg.excludeAI) products = products.filter(function(p) { return (p.tags || []).indexOf('ai-card') === -1; });
      indexProducts();
      readURL();
      if (sortEl) sortEl.value = sort;
      if (bar) bar.hidden = false;
      /* JS owns the grid now. Auto-load mode retires the page links
         VISUALLY only - .is-hidden is the sr-only clip, so the anchors stay
         in the DOM and stay crawlable. Batched mode keeps BOTH: the Load more
         button wired client-side as the control that advances the grid, and
         the page links left visible - the crawl path and the no-JS route to
         every product. */
      if (pagenav && !MANUAL) pagenav.classList.add('is-hidden');
      if (loadBtn) {
        if (MANUAL) {
          loadBtn.removeAttribute('data-next');      /* client-side from here */
          loadBtn.addEventListener('click', function () {
            if (remaining() <= 0) return;
            renderBatch(false);
            /* A windowed ?page= URL keeps its own address - ?offset= means
               "everything from the top", which is not what is on screen. */
            if (startAt === 0) writeURL(true);       /* each batch = a history entry */
            syncLoadBtn();
          });
        } else {
          loadBtn.hidden = true;
        }
      }
      apply({ noURL: true });
      restore();
      syncLoadBtn();
      maybeLoad();
    }).catch(function () {
      /* Data fetch failed: the server-rendered grid, Load more link and page
         links stay fully functional. Filters simply do not appear. */
      if (loadBtn) loadBtn.addEventListener('click', function () {
        var next = loadBtn.getAttribute('data-next');
        if (!next) return;
        loadBtn.disabled = true;
        loadBtn.textContent = cfg.loadingLabel || 'Loading…';
        fetch(next, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inc = doc.querySelector('[data-mb2-grid]');
            var nb = doc.querySelector('[data-mb2-loadbtn]');
            if (inc) while (inc.firstElementChild) grid.appendChild(inc.firstElementChild);
            loadBtn.disabled = false;
            loadBtn.textContent = cfg.loadMoreLabel || 'Load more';
            if (nb && nb.getAttribute('data-next')) loadBtn.setAttribute('data-next', nb.getAttribute('data-next'));
            else loadBtn.parentNode.removeChild(loadBtn);
          })
          .catch(function () { loadBtn.disabled = false; loadBtn.textContent = cfg.loadMoreLabel || 'Load more'; });
      });
    });
  }

  boot();
})();